"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var storage_service_1 = require("./storage.service");
var MigrationService = (function () {
    function MigrationService(storageService) {
        this.storageService = storageService;
    }
    MigrationService.prototype.migrate = function () {
        this.removeAndReplacePGIfNeeded();
        this.removeAndReplaceOldfIfNeeded();
    };
    MigrationService.prototype.removeAndReplacePGIfNeeded = function () {
        var storage = this.storageService.getStorage();
        if (storage.SharedPreferences) {
            return;
        }
        for (var oldProperty in storage) {
            if (oldProperty.indexOf('PG') !== -1) {
                var oldPropertyPG = oldProperty;
                var newPropertyWithoutPG = oldPropertyPG.slice(2);
                if (newPropertyWithoutPG === 'SharedPreferences') {
                    var oldPropertyPGValue = this.storageService.getObject(oldPropertyPG);
                    this.storageService.save(newPropertyWithoutPG, oldPropertyPGValue);
                }
                else if (newPropertyWithoutPG === 'LevelsResult') {
                    var oldPropertyPGValue = this.storageService.getObject(oldPropertyPG);
                    for (var levelId in oldPropertyPGValue) {
                        var level = oldPropertyPGValue[levelId];
                        level.e_moves = level.elementaryMoves;
                        level.v_count = level.foundVariantsCount;
                        level.l_moves = level.lineMoves;
                        delete level.elementaryMoves;
                        delete level.foundVariantsCount;
                        delete level.lineMoves;
                    }
                    this.storageService.save(newPropertyWithoutPG, oldPropertyPGValue);
                }
                else {
                    var oldPropertyPGValue = this.storageService.get(oldPropertyPG);
                    if (!oldPropertyPGValue) {
                        this.storageService.save(newPropertyWithoutPG, []);
                    }
                    else {
                        this.storageService.save(newPropertyWithoutPG, oldPropertyPGValue.split(','));
                    }
                }
                this.storageService.remove(oldPropertyPG);
            }
        }
    };
    MigrationService.prototype.removeAndReplaceOldfIfNeeded = function () {
        var tokenFromOldSite = this.storageService.get('CurrentUser');
        var wasLoginFromOldSite = this.storageService.get('wasLogin');
        var usersFromOldSite = this.storageService.get('Users');
        if (tokenFromOldSite) {
            this.storageService.saveString('userToken', tokenFromOldSite);
            this.storageService.remove('CurrentUser');
        }
        if (wasLoginFromOldSite) {
            this.storageService.remove('wasLogin');
        }
        if (usersFromOldSite) {
            this.storageService.remove('Users');
        }
    };
    return MigrationService;
}());
MigrationService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [storage_service_1.StorageService])
], MigrationService);
exports.MigrationService = MigrationService;



//////////////////
// WEBPACK FOOTER
// ./src/services/migration.service.ts
// module id = 262
// module chunks = 0